import { IConfig } from '@cian/config/shared';
import { TDeviceType } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { useSelector } from 'react-redux';

import { isAbUseExperimentActive } from './isAbUseExperimentActive';
import { useApplicationContext } from '../../containers/ApplicationContext';
import { selectExperiments } from '../../selectors/experiments';
import { TExperimentsState } from '../../types/experiments';

// Эксперимент автоматической установки дат если они не были выбраны пользователем
export function useDatesAutoSetExperimentActive() {
  const { config } = useApplicationContext();
  const experiments = useSelector(selectExperiments);
  const deviceType = useDeviceType();

  return getDatesAutoSetExperimentActive(config, experiments, deviceType);
}

export function getDatesAutoSetExperimentActive(
  config: IConfig,
  experiments: TExperimentsState,
  deviceType: TDeviceType,
) {
  const experimentName = config.get<string>('Dailyrent.Experiment.DatesAutoSetMobWeb.Name') || '';
  const targetExperimentGroup = config.get<string>('Dailyrent.Experiment.DatesAutoSetMobWeb.TargetGroup') || '';

  return deviceType === 'phone' && isAbUseExperimentActive(experiments, experimentName, targetExperimentGroup);
}
